module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/hall-list/plan-wedding-lineup-tokai-1-351877b2dbfc6d70df74fd838a913958.jpg";